import { render, staticRenderFns } from "./absorbance.vue?vue&type=template&id=6861a38a&scoped=true&"
import script from "./absorbance.vue?vue&type=script&lang=js&"
export * from "./absorbance.vue?vue&type=script&lang=js&"
import style0 from "./absorbance.vue?vue&type=style&index=0&id=6861a38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6861a38a",
  null
  
)

export default component.exports